import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleCreateAttendance } from "../../../api/training";
import { useState } from "react";

export default function AttendanceTaking({
  isVisible,
  setVisible,
  training_id,
  enrollment,
  attended,
}: any) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate } = useMutation({
    mutationFn: handleCreateAttendance,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["allTrainings", training_id],
      });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    setLoading(true);
    const { reason } = await form.getFieldsValue();
    const data = {
      attended,
      reason,
      user: enrollment?._id,
      enrolment: enrollment?._id,
    };
    await mutate({ data, training_id });
    setVisible(false);
    setLoading(false);
  };

  return (
    <Modal
      open={isVisible}
      title="Attendance Taking"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="AttendanceTaking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="AttendanceTaking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>
        <div className="flex flex-col justify-center items-center">
          <div className="text-center text-lg font-bold">
            {enrollment?.name}
          </div>
          <div className="">{enrollment?.company?.name}</div>
        </div>
        <div className="flex justify-center">
          {attended ? (
            <div className="text-green-600 font-bold">PRESENT </div>
          ) : (
            <div className="text-red-600 font-bold">ABSENT</div>
          )}
        </div>

        {!attended && (
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                name="reason"
                label="Reason (Optional)"
                rules={[
                  {
                    required: false,
                    message: "Please enter reason of absence",
                  },
                ]}
              >
                <Input type="" placeholder="Reason of Absence" />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </Modal>
  );
}
